import React from 'react';
import { RelativeContainer, SpinnerContainer, SpinnerOverlay, StyledSpinner } from './styles';
import { TextParagraph } from '~/theme';
import { useTranslation } from 'next-i18next';

interface SpinnerProps {
    isLoading: boolean;
    style?: 'default' | 'small';
    children?: React.ReactElement;
    microcopy?: string;
}

const renderSpinner = (size: 'default' | 'small') => {
    return (
        <StyledSpinner $size={size} viewBox="25 25 50 50" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="20" fill="none" strokeWidth="4" />
        </StyledSpinner>
    );
};

const Spinner = ({ isLoading, children, microcopy, style = 'default' }: SpinnerProps) => {
    const { t } = useTranslation('common');

    if (style === 'small' && !React.isValidElement(children)) {
        return renderSpinner(style);
    }

    return (
        <RelativeContainer>
            <SpinnerOverlay
                role="alert"
                aria-live="assertive"
                aria-hidden={!isLoading}
                $hidden={!isLoading}
                $blockPage={!React.isValidElement(children)}
            >
                <SpinnerContainer>
                    {renderSpinner(React.isValidElement(children) ? style : 'default')}
                    {style === 'default' && (
                        <TextParagraph>
                            {microcopy ?? t('common:spinner.loading', { defaultValue: 'Loading' })}
                        </TextParagraph>
                    )}
                </SpinnerContainer>
            </SpinnerOverlay>
            {children && children}
        </RelativeContainer>
    );
};

export default Spinner;
